import React from 'react';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';
import {createSelector} from 'reselect';
import {getTranslations, getSystem} from '../../selectors/store';
import {getGeneratedLocaleFormatted} from '../../utils/localeUtils';

export function IntlProviderWrapper({locale, messages, children}) {
    return (
        <IntlProvider locale={locale} messages={messages}>
            {children}
        </IntlProvider>
    );
}

const selectProps = createSelector(
    [getTranslations, getSystem],
    (translations, {displayLocale}) => {
        return {
            messages: translations,
            locale: getGeneratedLocaleFormatted(displayLocale)
        };
    }
);
const mapStateToProps = (state) => selectProps(state);

export default connect(mapStateToProps)(IntlProviderWrapper);
